import { render } from "./IconRefresh.vue?vue&type=template&id=3517207c"
import script from "./IconRefresh.vue?vue&type=script&lang=ts"
export * from "./IconRefresh.vue?vue&type=script&lang=ts"
script.render = render

export default script